import InfiniteScroll from 'react-infinite-scroll-component';
import { useState } from 'react';
import { IssuerTransferItem } from '@/modules/issuer-dashboard/components/items/IssuerTransferItem.tsx';
import { useIssuerTransferListQuery } from '@/modules/issuer-dashboard/queries/transfers.tsx';
import { CustomCheckbox, EmptyListState, Spinner } from 'ui';
import { GetIssuerTransferListV1SrTransfersIssuerGetParams, SortedBy } from 'api';

export type transferTabFilters = Omit<
  GetIssuerTransferListV1SrTransfersIssuerGetParams,
  'page' | 'page_size' | 'sorted_by'
>;

export interface IssuerTransferTabProps {
  register_id: number;
  filters: transferTabFilters;
}

export const IssuerTransfersTab = ({ register_id, filters }: IssuerTransferTabProps) => {
  const [isShowActionFirst, setIsShowActionFirst] = useState(false);

  const {
    data: issuerTransfersList,
    fetchNextPage,
    hasNextPage,
    isLoading: isIssuerPaymentsLoading,
  } = useIssuerTransferListQuery(
    {
      page: 1,
      page_size: 15,
      sorted_by: isShowActionFirst ? SortedBy.Status : SortedBy.RequestedAtDate,
      ...filters,
    },
    false,
    Number(register_id),
  );

  if (isIssuerPaymentsLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-start">
      <div className="w-full flex items-center justify-between pb-4">
        <CustomCheckbox
          label="Show Action required first"
          checked={isShowActionFirst}
          onChange={e => setIsShowActionFirst(e.target.checked)}
          className="select-none"
        />
        <div></div>
      </div>
      <EmptyListState
        title="No transfers yet"
        description="You can click on Add transfer to manually create transfer. Alternatively, investors can initiate transfers themselves from their dashboard but you will need to approve them."
        isLoading={isIssuerPaymentsLoading}
        isSearchUsed={false}
        itemsCount={issuerTransfersList?.pages.flatMap(({ data }) => data).length ?? 0}
      />
      <InfiniteScroll
        next={fetchNextPage}
        dataLength={issuerTransfersList?.pages.length ?? 0}
        hasMore={hasNextPage || false}
        style={{ overflow: 'unset' }}
        loader={
          <div className="flex justify-center items-center h-16 w-full">
            <Spinner size="md" variant="primary" />
          </div>
        }
        scrollableTarget="scrollable"
      >
        <div className="w-full flex flex-col space-y-2">
          {issuerTransfersList?.pages.map(({ data }) =>
            data.map(transfer => (
              <IssuerTransferItem
                key={transfer.id}
                {...transfer}
                register_id={register_id}
                isDeleted={filters.is_deleted}
                showArchiveButton={true}
              />
            )),
          )}
        </div>
      </InfiniteScroll>
    </div>
  );
};
